/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/

import React, {useEffect, useState} from 'react';
import Tooltip from '@mui/material/Tooltip';
import {intl} from '../../helper/IntlGlobalProvider';

function CustomTooltip(props) {
	const {header, message, messageValues} = props;
	const [open, setOpen] = useState(false);

	const onMouseDown = () => {
		setOpen(false);
	}

	useEffect(() => {
		document.addEventListener('mousedown', onMouseDown, false);

		return () => document.removeEventListener('mousedown', onMouseDown, false);
	}, []);


	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
		document.removeEventListener('mousedown', onMouseDown, false);
	};

	return (
		<Tooltip
			enterDelay={300}
			onOpen={() => handleOpen()}
			onClose={() => handleClose()}
			open={ open }
			title={
				<React.Fragment>
					<div style={{
						fontWeight: 'bold',
						marginBottom: '8px',
					}}
					>
						 {intl.formatMessage({id: header}, {})}
					</div>
					<div color="transparent">
						 {intl.formatMessage({id: message}, messageValues)}
					</div>
				</React.Fragment>
			}
		>
			<div style={{ border: '0', display: 'inline' }} >
				{props.children}
			</div>
		</Tooltip>
	);
}

export default CustomTooltip;
